import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=4c6b4e06&scoped=true&"
import script from "./DialogLoading.vue?vue&type=script&lang=js&"
export * from "./DialogLoading.vue?vue&type=script&lang=js&"
import style0 from "./DialogLoading.vue?vue&type=style&index=0&id=4c6b4e06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b4e06",
  null
  
)

export default component.exports